<template>
  <div class="header">
    <div class="logo-box">
      <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png"/>
    </div>
    <div class="top-menu">
      <div v-if='curPage=="home"' class="top-menu-item menu-item-active">首页</div>
      <div v-else class="top-menu-item" @click="navTo('/', 'home')">首页</div>
      <div v-if='curPage=="refactorProduct"' class="top-menu-item menu-item-active">产品服务</div>
      <div v-else class="top-menu-item" @click="navTo('/refactorProduct', 'refactorProduct')">产品服务</div>
      <div v-if='curPage=="refactorCase" || curType==4' class="top-menu-item menu-item-active">客户案例</div>
      <div v-else class="top-menu-item" @click="navTo('/refactorCase', 'refactorCase')">客户案例</div>
      <div v-if='curPage=="refactorNews" || curType==1' class="top-menu-item menu-item-active">灰鲸资讯</div>
      <div v-else class="top-menu-item" @click="navTo('/refactorNews', 'refactorNews')">灰鲸资讯</div>
      <div v-if='curPage=="refactorAbout"' class="top-menu-item menu-item-active">关于我们</div>
      <div v-else class="top-menu-item" @click="navTo('/refactorAbout', 'refactorAbout')">关于我们</div>
    </div>
    <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
      <div class="login-btn">
        登录
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curPage: "",
    }
  },
  props: {
    curType: {
      type: Number,
      default: 0
    }
  },
  created() {
    // 初始化当前页面
    this.updateCurPage()
  },
  watch: {
    // 监听路由变化，自动更新当前页面
    $route: {
      handler: function() {
        this.updateCurPage()
      },
      immediate: true
    }
  },
  methods: {
    navTo(url, page) {
      this.curPage = page;
      this.$router.push({path: url})
    },
    goUrl(url) {
      window.open(url);
    },
    // 更新当前页面
    updateCurPage() {
      const path = this.$route.path;
      if (path === '/home') {
        this.curPage = 'home';
      } else if (path.startsWith('/refactor')) {
        this.curPage = path.substring(1); // 去掉斜杠
      }
    }
  }
}
</script>

<style lang="less">
.header {
  background-color: #FFFFFF;
  display: flex;
  height: 80px;
  position: fixed;  // 添加固定定位
  top: 0;          // 固定在顶部
  left: 0;         // 从左侧开始
  right: 0;        // 延伸到右侧
  z-index: 1000;   // 确保在其他元素之上

  .logo-box {
    flex: 1;
    display: flex;
    align-items: center;

    .logo {
      margin-left: 40px;
      width: 205px;
      height: 30px;
    }
  }

  .top-menu {
    flex: 1;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 80px;
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    // padding-left: 60%;
    .top-menu-item {
      // margin-right: 38px;
      cursor: pointer;
    }

    .menu-item-active {
      cursor: default;
      color: #0B00B5;
      font-weight: bold;
    }
  }

  .login-box {
    flex: 1;
    cursor: pointer;

    .login-btn {
      width: 120px;
      height: 80px;
      background: #0B00B5;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 80px;
      text-align: center;
      font-style: normal;
      float: right;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/header-menu.vue